import { render } from "./NotFound.vue?vue&type=template&id=200743c4"
const script = {}

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__